import { Navigate, useParams } from 'react-router-dom';
import { useDocumentationShell } from './documentationShell';

/** Rotas legadas `/edit` e `/pages/new` redirecionam para a view com edição inline. */
export function DocumentationPageEditorPage() {
  const { spaceId = '', pageId } = useParams();
  const shell = useDocumentationShell();
  const isNew = !pageId || pageId === 'new';

  if (isNew) {
    return <Navigate to={`${shell.basePath}/${spaceId}?create=1`} replace />;
  }

  return <Navigate to={`${shell.basePath}/${spaceId}/pages/${pageId}?edit=1`} replace />;
}
